import React from 'react';
import styled from 'styled-components';
import { colors } from '../../utils/colors.js';

const Card = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconWrap = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${(props) => props.$bg || colors.primary[100]};
  color: ${(props) => props.$color || colors.primary[600]};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
`;

const Value = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${colors.gray[900]};
  line-height: 1.1;
`;

const Label = styled.div`
  font-size: 13px;
  color: ${colors.gray[500]};
  margin-top: 2px;
`;

export default function KpiCard({ icon: Icon, label, value, color, bg }) {
  return (
    <Card>
      {Icon && (
        <IconWrap $color={color} $bg={bg}>
          <Icon />
        </IconWrap>
      )}
      <div>
        <Value>{value ?? '—'}</Value>
        <Label>{label}</Label>
      </div>
    </Card>
  );
}
